<template>

    <div>

        <div class="modal fade" :id="idName" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title titulo-modal" id="exampleModalLabel">{{title}}</h5>
                <div ref="elementCloseModalCentral" data-dismiss="modal" class="close-container">
                    <div class="leftright"></div>
                    <div class="rightleft"></div>
                </div>                
            </div>
            <div class="modal-body">
                <component @closeModal="closeModalCentral" :is="componentName" :data="data" :slides="slides" @emit="emit()"></component>
            </div>
            </div>
        </div>
        </div>

    </div>    
</template>

<script>

import AddUser from './Forms/AddUser'
import AddUserMunic from './Forms/AddUserMunic'
import AddUserUe from './Forms/AddUserUe'
import AddEducationalUnit from './Forms/AddEducationalUnit'
import AddEducationalUnitByFile from './Forms/AddEducationalUnitByFile'
import AddField from './Forms/AddField'
import AddClass from './Forms/AddClass'
import AddClassByFile from './Forms/AddClassByFile'
import ChangePermission from './Forms/ChangePermission'
import Carousel from './Carousel'
import SearchInstitution from './Forms/SearchInstitution'
import CreateInstitution from './Forms/CreateInstitution'
import CreateGroup from './Forms/CreateGroup'
import Profile from './Forms/Profile'
import Information from './Forms/Information'
import InstiRequests from './Forms/InstiRequests'
import ShowCampoInfo from './Forms/ShowCampoInfo'
import UserInvites from './Forms/UserInvites'
import show_member_info from './Forms/show_member_info.vue'
import CreateRegional from './Forms/CreateRegional.vue'
import FormularioInfo from './Forms/FormularioInfo.vue'
import SobreConceitos from './Dados/SobreConceitos.vue'
import MembroCampoInfo from './Forms/MembroCampoInfo.vue'
import AplicacaoInfo from './Dados/AplicacaoInfo.vue'
import AddDevolutiva from './Forms/AddDevolutiva.vue'


export default {
    name: 'ModalCentral',
    components:{
        AddUser,
        AddUserMunic,
        AddUserUe,
        AddEducationalUnit,
        AddEducationalUnitByFile,
        AddField,
        AddClass,
        AddClassByFile,
        ChangePermission,
        Carousel,
        SearchInstitution,
        CreateInstitution,
        CreateGroup,
        Profile,
        Information,
        InstiRequests,
        ShowCampoInfo,
        UserInvites,
        show_member_info,
        CreateRegional,
        FormularioInfo,
        SobreConceitos,
        MembroCampoInfo,
        AplicacaoInfo,
        AddDevolutiva

    },
    props: {
        componentName: String,
        title: String,
        idName: String,
        data: [Object, String, Array],
        hasButtonLeft: Boolean,
        hasButtonRight: Boolean,
        slides: Object
    },
    methods: {
        closeModalCentral(){
            this.$refs.elementCloseModalCentral.click()
        },
        emit(){
            this.$emit('emit');
        }
    },
 
}
</script>

<style scoped>

    .titulo-modal{
        margin: 0;
    }

    .close-container{
        position: relative;
        margin-right: 0;
        width: 30px;
        height: 30px;
        cursor: pointer;
    }

    .leftright{
        height: 2.5px;
        width: 20px;
        position: absolute;
        margin-top: 12px;
        background-color: #414141;
        border-radius: 2px;
        transform: rotate(45deg);
        transition: all .3s ease-in;
    }

    .rightleft{
        height: 2.5px;
        width: 20px;
        position: absolute;
        margin-top: 12px;
        background-color: #414141;
        border-radius: 2px;
        transform: rotate(-45deg);
        transition: all .3s ease-in;
    }

    .close-container:hover .leftright{
        transform: rotate(-45deg);
        background-color: #F25C66;
    }
    .close-container:hover .rightleft{
        transform: rotate(45deg);
        background-color: #F25C66;
    }

    .modal-body{
        /* height: 50vh; */
        overflow: overlay;
    }
    .modal-body::-webkit-scrollbar {
        width: 0.5rem;
    }
    
    .modal-body::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
        box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
        border-radius: 10px;
    }
    
    .modal-body::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: var(--dark); 
    }
    
</style>
